import { Assets, Spritesheet, Texture } from 'pixi.js'
import { SYMBOL_NAMES } from '../constants'

// 符號貼圖登錄 — 由 scripts/gen-atlas.mjs 合成的 spritesheet（public/atlas/symbols.webp + .json）取得。
// frame key 即符號名稱（WW、H1…LJ）；索引對應 SYMBOL_NAMES。
const textures = new Map<number, Texture>()

const ATLAS = `${import.meta.env.BASE_URL}atlas/symbols.json`

export async function loadSymbolTextures(): Promise<void> {
  const sheet = await Assets.load<Spritesheet>(ATLAS)
  SYMBOL_NAMES.forEach((name, id) => {
    const tex = sheet.textures[name]
    if (tex) textures.set(id, tex)
  })
}

export function symbolTexture(id: number): Texture | null {
  return textures.get(id) ?? null
}
